import angular from 'angular';

const name = 'mmsIncludeUppercase';
export const IncludeUppercaseDirective = {
    name,
    directive: directive
};

function directive(UtilService) {
    'ngInject';
    return {
        restrict: 'A',
        scope: true,
        require: 'ngModel',
        link: function($scope, $element, $attrs, ngModel) {
            let includeCount = 0;
            $attrs.$observe(name, function(value) {
                includeCount = parseInt(value, 10);
                ngModel.$validate();
            });

            ngModel.$validators[name] = (modelValue, viewValue) => {
                return UtilService.countUppercase(viewValue) >= includeCount;
            };
        }
    };
}


// WEBPACK FOOTER //
// ./src/app/directives/includeUppercase.directive.js